var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Burger_burgerButton, _Burger_headerNav, _Burger_body, _Burger_isMenuOpen;
export class Burger {
    constructor() {
        var _a, _b;
        _Burger_burgerButton.set(this, document.getElementById("burger"));
        _Burger_headerNav.set(this, document.getElementById("nav"));
        _Burger_body.set(this, document.querySelector("body"));
        _Burger_isMenuOpen.set(this, false);
        (_a = __classPrivateFieldGet(this, _Burger_burgerButton, "f")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", (event) => {
            event.stopPropagation();
            this.classesToggle();
            this.toggleMenu();
        });
        (_b = __classPrivateFieldGet(this, _Burger_body, "f")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", (event) => {
            var _a;
            event.stopPropagation();
            if (event.target.closest("header") &&
                __classPrivateFieldGet(this, _Burger_isMenuOpen, "f") &&
                ((_a = event.target.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "a") {
                this.toggleMenu();
                this.classesToggle();
            }
        });
    }
    classesToggle() {
        var _a, _b, _c;
        (_a = __classPrivateFieldGet(this, _Burger_burgerButton, "f")) === null || _a === void 0 ? void 0 : _a.classList.toggle("burger--cancel");
        (_b = __classPrivateFieldGet(this, _Burger_headerNav, "f")) === null || _b === void 0 ? void 0 : _b.classList.toggle("nav--appear");
        (_c = __classPrivateFieldGet(this, _Burger_body, "f")) === null || _c === void 0 ? void 0 : _c.classList.toggle("body__fixed");
    }
    toggleMenu() {
        if (__classPrivateFieldGet(this, _Burger_isMenuOpen, "f")) {
            __classPrivateFieldSet(this, _Burger_isMenuOpen, false, "f");
        }
        else {
            __classPrivateFieldSet(this, _Burger_isMenuOpen, true, "f");
        }
    }
}
_Burger_burgerButton = new WeakMap(), _Burger_headerNav = new WeakMap(), _Burger_body = new WeakMap(), _Burger_isMenuOpen = new WeakMap();
